exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.multiselect__tag {\r\n    background: #adadad;\n}\n.multiselect__tag-icon:after {\r\n    color: black;\n}\n.multiselect__option--highlight {\r\n    background: #707070;\n}\n.swal2-container {\r\n    z-index: 999999999 !important;\n}\n.dropzone .dz-preview .dz-image img {\r\n    width: 100%;\r\n    height: 100%;\r\n    -o-object-fit: cover;\r\n       object-fit: cover;\n}\r\n", ""]);

// exports
